import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

// Helper do shadcn/ui: mescla classes condicionais (clsx) resolvendo
// conflitos de utilitários Tailwind (tailwind-merge).
export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}
